// extracted by mini-css-extract-plugin
export default {"root":"CommentContent-root-e1ad1e8c0ecd6e55234ac00013b534e6","highlight":"CommentContent-highlight-e7be294cf136a48974aa96f922f4581d"};